import { formatRelativeActivity } from '../../../utils/dates';

interface LastActivityProps {
    lastActivityAt: string | null;
}

export function LastActivity({ lastActivityAt }: LastActivityProps) {
    const relative = formatRelativeActivity(lastActivityAt);
    if (!relative) {
        return <span className="text-[13px] text-gray-300">Never signed in</span>;
    }
    return <span className="text-[13px] text-gray-500">{relative}</span>;
}
